import styled from 'styled-components';
import { ieOnly } from '../../styles/ieOnly';

/** Renders a semi-transparent image with all its opaque areas coloured-in with
 * the current text colour.
 */
export const ColouredImageMask = styled.div.attrs({ role: 'img' })<{ src: string }>`
  background-color: currentColor;
  display: inline-block;
  mask-repeat: no-repeat;
  mask-image: url('${props => props.src}');

  /** IE11 does not support mask-image, so we fall back to using an (uncoloured) background image */
  ${ieOnly} {
    background-color: transparent;
    background-image: url('${props => props.src}');
  }
`;
